import { SpaceBetween } from "@cloudscape-design/components-themed";
import { MerchantInfo } from "./merchant-info/MerchantInfo";
import { ApplicantCompany } from "./applicant-company/ApplicantCompany";
import { ReferenceGroup } from "./reference-group/ReferenceGroup";
import { BankAccount } from "./bank-account/BankAccount";
import { PaymentCycle } from "./payment-cycle/PaymentCycle";
import { PaymentTargetCompany } from "./payment-target-company/PaymentTargetCompany";
import { Footer } from "./Footer";
import { useContext, useEffect, useState } from "react";
import { BankAccountInquiryContext } from "../../pages/BankAccountsInquiry";
import { UpdatingContentModal } from "./UpdatingContentModal";
import { IErrMsg } from "./constants";
import {
  BankAccountsUpdateRequest,
  SettlementNoticeEmail,
} from "../../features/api-interfaces";
import { CODE_MASTER } from "../default-constants";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { SettlementNotice } from "./settlement-notice/SettlementNotice";

/**
 * 入金口座情報照会・更新
 */
export const Main = () => {
  const { pathname } = useLocation();
  const { companyContractBankAccountNo, apiResponse, isFetching } = useContext(
    BankAccountInquiryContext
  )!;
  const updatingInfo = apiResponse?.updatingInfo;
  const applyingDate = apiResponse?.applyingDate;
  const referenceGroup = apiResponse?.prodInfo.referenceGroup;
  const bankAccount = apiResponse?.prodInfo.bankAccount;
  const paymentCycleCode = apiResponse?.prodInfo.paymentCycleCode;
  const paymentTargetCompany = apiResponse?.prodInfo.paymentTargetCompany;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errMsg, setErrMsg] = useState<IErrMsg>({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [editingRequest, setEditingRequest] =
    useState<BankAccountsUpdateRequest>({
      companyContractBankAccountNo: 0,
      settlementNoticeEmailList: [],
      fnnInsMthStrCd: "",
      fnnInsMthStrNm: "",
      fnnInsBrnCd: "",
      fnnInsBrnNm: "",
      bankAccountType: 0,
      bankAccountNumber: "",
      bankAccountHolderKana: "",
      paymentCycleCode: "",
      corporateNumber: "",
      companyName: "",
      companyNameKana: "",
      postalCode: "",
      paymentTargetCompanyAddress1: "",
      paymentTargetCompanyAddress2: "",
      paymentTargetCompanyAddress1Kana: "",
      phoneNumber: "",
    });
  const [tempEmailList, setTempEmailList] = useState<SettlementNoticeEmail[]>(
    []
  );

  useEffect(() => {
    setIsUpdate(pathname.includes("update"));
  }, [pathname]);

  useEffect(() => {
    // 更新モード切り替え時にエラーメッセージを初期化する
    setErrMsg({});

    if (!isEmpty(apiResponse)) {
      const settlementNoticeEmailList =
        apiResponse?.prodInfo.settlementNoticeEmailList;
      setEditingRequest({
        companyContractBankAccountNo,
        settlementNoticeEmailList,
        fnnInsMthStrCd: bankAccount?.fnnInsMthStrCd ?? "",
        fnnInsMthStrNm: bankAccount?.fnnInsMthStrNm ?? "",
        fnnInsBrnCd: bankAccount?.fnnInsBrnCd ?? "",
        fnnInsBrnNm: bankAccount?.fnnInsBrnNm ?? "",
        bankAccountType:
          bankAccount?.bankAccountType ??
          Number(CODE_MASTER["BANK_ACCOUNT_TYPE"][0].value),
        bankAccountNumber: bankAccount?.bankAccountNumber ?? "",
        bankAccountHolderKana: bankAccount?.bankAccountHolderKana ?? "",
        paymentCycleCode:
          paymentCycleCode ?? CODE_MASTER["PAYMENT_CYCLE_CODE"][0].value,
        corporateNumber: paymentTargetCompany?.corporateNumber ?? "",
        companyName: paymentTargetCompany?.companyName ?? "",
        companyNameKana: paymentTargetCompany?.companyNameKana ?? "",
        postalCode: paymentTargetCompany?.postalCode ?? "",
        paymentTargetCompanyAddress1: paymentTargetCompany?.address ?? "",
        paymentTargetCompanyAddress2:
          paymentTargetCompany?.addressDetails ?? "",
        paymentTargetCompanyAddress1Kana:
          paymentTargetCompany?.addressKana ?? "",
        phoneNumber: paymentTargetCompany?.phoneNumber ?? "",
      });
      setTempEmailList(settlementNoticeEmailList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResponse, isUpdate]);

  return (
    <>
      <SpaceBetween direction="vertical" size="l">
        <MerchantInfo
          updatingInfo={updatingInfo}
          applyingDate={applyingDate}
          merchantInfoList={apiResponse?.prodInfo.merchantInfo}
          setIsModalOpen={setIsModalOpen}
        />
        <ApplicantCompany
          applicantCompany={apiResponse?.prodInfo.applicantCompany}
        />
        <ReferenceGroup referenceGroup={referenceGroup} />
        <SettlementNotice
          emailList={tempEmailList}
          setEmailList={setTempEmailList}
          isUpdate={isUpdate}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <BankAccount
          bankAccount={bankAccount}
          isUpdate={isUpdate}
          editingRequest={editingRequest}
          setEditingRequest={setEditingRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <PaymentCycle
          paymentCycleCode={paymentCycleCode}
          isUpdate={isUpdate}
          editingRequest={editingRequest}
          setEditingRequest={setEditingRequest}
        />
        <PaymentTargetCompany
          isFetching={isFetching}
          paymentTargetCompany={paymentTargetCompany}
          isModalOpen={isModalOpen}
          isUpdate={isUpdate}
          editingRequest={editingRequest}
          setEditingRequest={setEditingRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
        <Footer
          isFetching={isFetching}
          companyContractBankAccountNo={companyContractBankAccountNo}
          updatingInfo={updatingInfo}
          applyingDate={applyingDate}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          editingRequest={editingRequest}
          settlementNoticeEmailList={tempEmailList}
          setErrMsg={setErrMsg}
        />
      </SpaceBetween>
      <UpdatingContentModal
        isFetching={isFetching}
        apiResponse={apiResponse}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      />
    </>
  );
};
